// extracted by mini-css-extract-plugin
module.exports = {"gridFull":"GridFull_gridFull__we3YY"};